const $FONT_FAMILY = 'Lato';
const $FONT_MONTSERRAT = 'Montserrat';
const $CONTAINER_WIDTH_VW = '100%';
const $CONTAINER_MAX_WIDTH = '960px';
const $CONTAINER_WIDTH_LOGIN_REGISTER = "700px";
const $CONTAINER_HEIGHT_VH = "100vh";
const $CONTAINER_MARGIN = 'auto';
const $COLOR_PRIMARY = '#8B2FF1 ';
const $COLOR_SECONDARY = '#F2AC49';
const $COLOR_DANGER = '#FF7875';
const $COLOR_ALICE_BLUE = "#F0F8FF";
const $COLOR_TABLE_TENUE = "#D7E7DF";
const $COLOR_TABLE_FORTE = "#B7C5BE";
const $COLOR_WHITE = '#FFFFFF';
const $COLOR_GRIS = '#333333';
const $COLOR_BLACK = '#111111';
const $COLOR_SCROLLBAR = '#ccc';
const $COLOR_TRANSPARENT = 'transparent';
const $MOVILE = '375px';
const $TABLET = '768px';
const $DESKTOP = '1024px';
const $DEVICE_SPECIAL_SALE = "870px";

export {
    $FONT_FAMILY,
    $FONT_MONTSERRAT,
    $CONTAINER_WIDTH_VW,
    $CONTAINER_MAX_WIDTH,
    $CONTAINER_WIDTH_LOGIN_REGISTER,
    $CONTAINER_HEIGHT_VH,
    $CONTAINER_MARGIN,
    $COLOR_PRIMARY,
    $COLOR_SECONDARY,
    $COLOR_DANGER,
    $COLOR_ALICE_BLUE,
    $COLOR_TABLE_TENUE,
    $COLOR_TABLE_FORTE,
    $COLOR_WHITE,
    $COLOR_GRIS,
    $COLOR_BLACK,
    $COLOR_SCROLLBAR,
    $COLOR_TRANSPARENT,
    $MOVILE,
    $TABLET,
    $DESKTOP,
    $DEVICE_SPECIAL_SALE
}